export function cleanSlug(slug?: string): string | undefined {
  return slug?.toLowerCase()?.replace(/\s/g, '')
}
